module.exports = __webpack_public_path__ + "img/close.07233e62.svg";